<template>
  <section class="event-list">
    <h2 v-html="title"></h2>
    <div
      class="wysiwyg"
      v-html="description"></div>
    <ul>
      <EventItem
        v-for="(item, key) in events"
        :key="`event${key}`"
        :item="item" />
    </ul>
  </section>
</template>

<script>
import EventItem from '@/components/base/EventItem'

export default {
  name: 'EventList',
  components: {
    EventItem
  },
  props: {
    title: {
      type: String,
      default: 'Events'
    },
    description: {
      type: String,
      default: null
    },
    events: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.event-list {
  ul {
    display: flex;
    flex-wrap: wrap;
    margin: $page-padding 0 0 0;
  }
}
</style>
